import {createFileRoute} from '@tanstack/react-router'
import {type} from 'arktype'

import stripDefaultSearchParams from '@/utils/router/middlewares/stripDefaultSearchParams'
import stripEmptySearchParams from '@/utils/router/middlewares/stripEmptySearchParams'
import stripZeroSearchParams from '@/utils/router/middlewares/stripZeroSearchParams'
import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  applyRewards: false,
  coupon: '',
}

const cartSearchSchema = type({
  applyRewards: fallbackToDefault(type.boolean, DEFAULT_VALUES.applyRewards),
  coupon: fallbackToDefault(searchParamString, DEFAULT_VALUES.coupon),
})

export const Route = createFileRoute('/_food-grubhub/food/cart')({
  validateSearch: cartSearchSchema,
  search: {
    middlewares: [
      stripDefaultSearchParams(DEFAULT_VALUES),
      stripZeroSearchParams(),
      stripEmptySearchParams(),
    ],
  },
})
